module.exports = __webpack_public_path__ + "fonts/iconfont.3f266ba6.woff2";